import React from 'react';
import Parts from './Parts';


function Banner(){
    return(
        <div id="banner">
        <h1>Welcome!</h1>
      </div>
    )
}

export default Banner;